import { Platform } from "react-native";

export const HORIZONTAL_CAROUSEL_ITEM_GAP = 16;
export const HORIZONTAL_CAROUSEL_MAX_ITEMS = 12;
export const HORIZONTAL_CAROUSEL_ARROW_BG = "rgba(255,255,255,0.5)";

const ARROW_SHADOW_STYLE_WEB = {
  boxShadow: "0px 0px 2px rgba(0,0,0,0.08), 0px 2px 4px rgba(0,0,0,0.12)",
} as object;

const ARROW_SHADOW_STYLE_NATIVE = {
  shadowColor: "#000000",
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.12,
  shadowRadius: 4,
  elevation: 3,
};

export const horizontalCarouselArrowShadowStyle =
  Platform.OS === "web" ? ARROW_SHADOW_STYLE_WEB : ARROW_SHADOW_STYLE_NATIVE;
